import { render, staticRenderFns } from "./EditEvents.vue?vue&type=template&id=6afa2d5a"
import script from "./EditEvents.vue?vue&type=script&lang=js"
export * from "./EditEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports